import {sellerConstants } from '../../../_constants/seller.constants';

const initialState = { removeSellerAdmin : true, data: '', error: false, errorText: ''};

export function removeSellerAdmin(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_REMOVE_SELLER_ADMIN:
        return {
          removeSellerAdmin: true,
          data: '',
          error: false,
          errorText: ''
        };
      case sellerConstants.REMOVE_SELLER_ADMIN_SUCCESS:
        return {
          removeSellerAdmin: false,
          data: action.data,
          error: false,
          errorText: ''
        };
      case sellerConstants.REMOVE_SELLER_ADMIN_ERROR:
        return { 
          removeSellerAdmin: false,
          data: '',
          error: true,
          errorText: action.error
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/sellerAdmin/removeSellerAdmin.reducer.js